import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircle from '@material-ui/icons/Add';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import { getAllVendors as getVendorList } from '../../store/actions/admin/Admin';
import {
  getAllCategory as getCategoryList,
  getCategoryDetails,
  deleteCategories
} from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

var update = false;
function CategoriesTable(props) {
  const classes = useStyles();
  const [page, setPage] = useState(1);

  useEffect(() => {
    props.getCategoryList(props.match.params.superCategoryId);
    props.getVendorList();
    setSuperCategoryIdFetcht(props.match.params.superCategoryId);
    setCategorySuper(props.match.params.superCategoryId);
  }, [update]);

  const [categorySuper, setCategorySuper] = React.useState(0);
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [superCategoryIdFetcht, setSuperCategoryIdFetcht] = useState('ajssj');
  const [modal2, setModal2] = useState(false);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);
  //   const [itemDetails, setItemDetails] = useState(`
  //   id: "63c0eeb0-206b-11eb-97d7-7dadae6d1a71",
  //   createdAt: 1604693117211,
  // updatedAt: 1604693117211`);
  const data = [];
  // {
  var c = 1;
  props.categories &&
    props.categories.map((category) => {
      data.push({
        sno: c,
        name: category
      });
      c += 1;
    });
  // }

  const fetchDetails = async (categoryId) => {
    // setItemDetails(props.categoryDetails);
    props.getCategoryDetails(categoryId);
  };

  const handleDelete = (categoryId) => {
    props.deleteCategories(categoryId);
    if (update === false) {
      update = true;
      setTimeout(() => {
        update = false;
      }, 2500);
    } else {
      update = true;
      update = false;
    }
  };
  const handlePagination = (event, value) => {
    setPage(value);
    props.getCategoryList(props.match.params.superCategoryId, value);
  };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All Categories - Add, Update, Delete
        </h4>
        <p className={classes.cardCategoryWhite}>
          PNG Images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Added by</th>
            <th>Name</th>
            <th>Icon</th>
            <th>Sub-Category</th>
            <th>Add</th>
            <th>Update</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.categories.length !== 0 ? (
            props.categories.map((item, i) => (
              <tr key={item.id}>
                <th scope="row">{i + 1}</th>
                {props.allVendors.filter(
                  (categorieFilter) => categorieFilter.id === item.addedBy
                ).length > 0 ? (
                  props.allVendors
                    .filter(
                      (categorieFilter) => categorieFilter.id === item.addedBy
                    )
                    .map((type) => <td key={type.id}>{type.name}</td>)
                ) : (
                  <td> A {item.userRoleOfAddedBy} </td>
                )}

                <td>{item.name}</td>
                <td>
                  <img
                    className="img-fluid"
                    src={item.icon}
                    alt={item.name}
                    style={{ height: '80px' }}
                  />
                </td>
                <td>
                  <Link
                    style={{ color: '#932BAD', textDecoration: 'none' }}
                    to={
                      '/vendor/sub-category/' +
                      item.superCategoryId +
                      '/' +
                      item.id
                    }
                  >
                    View All
                  </Link>
                </td>
                <td>
                  <Link
                    style={{ color: '#932BAD', textDecoration: 'none' }}
                    to={
                      '/vendor/add-sub-category/' +
                      categorySuper +
                      '/' +
                      item.id
                    }
                  >
                    <AddCircle
                      onClick={function (event) {
                        toggle();
                        fetchDetails(item.id);
                      }}
                    />{' '}
                    Add subCategory
                  </Link>
                </td>
                <td>
                  <Link
                    style={{ color: '#000' }}
                    to={
                      '/vendor/category-edit/' +
                      item.superCategoryId +
                      '/' +
                      item.id
                    }
                  >
                    <EditIcon
                      onClick={function (event) {
                        toggle();
                        fetchDetails(item.id);
                      }}
                    />{' '}
                  </Link>
                </td>
                <td>
                  <DeleteIcon
                    onClick={function (event) {
                      toggle();
                      setItemDelete(item.id);
                    }}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Pagination
        count={props.pageCount && props.pageCount - 1}
        color="primary"
        page={page}
        onChange={handlePagination}
      />
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Category??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a category</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Link to={'/vendor/add-category/' + superCategoryIdFetcht}>
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            fontFamily: 'Helvetica',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ marginTop: '22px', fontWeight: 600 }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
}

const mapStateWithProps = (state) => ({
  allVendors: state.admin.allVendors,
  categories: state.vendor.categories,
  categoryDetails: state.vendor.categoryDetails,
  pageCount: state.admin.pageCount
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getVendorList: (id) => dispatch(getVendorList(id)),
    getCategoryList: (superCategoryId, id) =>
      dispatch(getCategoryList(superCategoryId, id)),
    getCategoryDetails: (categoryId) =>
      dispatch(getCategoryDetails(categoryId)),
    deleteCategories: (categoryId) => dispatch(deleteCategories(categoryId))
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(CategoriesTable);
